var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ws-chip-002",class:[{green:_vm.green,yellow:_vm.yellow,red:_vm.red,outLine:_vm.outLine},_vm.color]},[_c('div',{staticClass:"ws-chip-002__text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }